import CertificationLogo from 'components/common/CertificationLogo/CertificationLogo';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CategoryDetail } from 'types/Search';
import './SearchCertificationList.scss';

interface SearchCertificationsProps {
  certifications: CategoryDetail[];
}

const SearchCertifications = ({
  certifications
}: SearchCertificationsProps) => {
  const getPlusCertificationsTooltip = () => {
    let plusCerts = '';

    certifications.forEach((certification: CategoryDetail, index: number) => {
      if (index !== 0 && index !== 1) {
        plusCerts += `${certification.value}; `;
      }
    });

    return plusCerts;
  };

  return (
    <div className="search-certification">
      {certifications && certifications.length > 0 && (
        <>
          {certifications.length <= 2 ? (
            certifications.map(
              (certification: CategoryDetail, index: number) => (
                <CertificationLogo
                  key={certification.value + '_' + index}
                  certificationValue={certification.value}
                />
              )
            )
          ) : (
            <>
              <CertificationLogo certificationValue={certifications[0].value} />
              <CertificationLogo certificationValue={certifications[1].value} />
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{getPlusCertificationsTooltip()}</Tooltip>}
              >
                <span className="search-certification-container search-certification-container--plus">
                  <div className="search-certification-image search-certification-image--plus">
                    +{certifications.length - 2}
                  </div>
                </span>
              </OverlayTrigger>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SearchCertifications;
